import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  const teamMembers = [
    {
      name: 'Sarah Johnson',
      role: 'Product Designer',
      image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20female%20product%20designer%20in%20modern%20office%20setting%2C%20clean%20background%2C%20business%20casual%20attire%2C%20friendly%20smile%2C%20natural%20lighting%2C%20high%20quality%20portrait&width=300&height=300&seq=team1&orientation=squarish',
      bio: 'Sarah brings 8 years of UX design experience, focusing on creating intuitive interfaces that make complex tasks simple.'
    },
    {
      name: 'Michael Chen',
      role: 'Lead Developer',
      image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20experienced%20male%20software%20developer%2C%20modern%20tech%20office%20background%2C%20casual%20business%20attire%2C%20confident%20expression%2C%20clean%20lighting%2C%20high%20quality%20portrait&width=300&height=300&seq=team2&orientation=squarish',
      bio: 'Michael is a full-stack developer with expertise in React, Node.js, and cloud architecture. He loves building scalable solutions.'
    },
    {
      name: 'Emma Rodriguez',
      role: 'Marketing Lead',
      image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20creative%20female%20marketing%20professional%2C%20bright%20office%20environment%2C%20stylish%20business%20attire%2C%20engaging%20smile%2C%20professional%20lighting%2C%20high%20quality%20portrait&width=300&height=300&seq=team3&orientation=squarish',
      bio: 'Emma specializes in digital marketing and user acquisition, with a track record of launching successful SaaS products.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About 
              <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent"> QikFinder</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We're on a mission to solve one of life's most frustrating problems: losing track of your belongings. 
              QikFinder is the smart solution that helps you organize, find, and manage your items effortlessly.
            </p>
          </div>

          {/* Story Section */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  QikFinder was born out of personal frustration. Our founders spent countless hours searching for 
                  misplaced items - from important documents to seasonal decorations stored away in the garage.
                </p>
                <p>
                  We realized that in our digital age, we have sophisticated systems to organize our photos, files, 
                  and contacts, but nothing for our physical belongings. That's when we decided to create QikFinder.
                </p>
                <p>
                  Our vision is simple: make finding your things as easy as searching the web. Whether you're a 
                  busy parent, a small business owner, or managing a large warehouse, QikFinder adapts to your needs.
                </p>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-8">
              <img 
                src="https://readdy.ai/api/search-image?query=modern%20organized%20workspace%20with%20labeled%20storage%20boxes%2C%20clean%20shelving%20system%2C%20digital%20tablet%20showing%20organization%20app%2C%20natural%20lighting%2C%20minimalist%20design%2C%20productivity%20focused%20environment&width=500&height=400&seq=about1&orientation=landscape" 
                alt="Organized workspace" 
                className="w-full h-80 object-cover rounded-xl"
              />
            </div>
          </div>

          {/* Values Section */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Innovation</h3>
                <p className="text-gray-600">
                  We constantly push the boundaries of what's possible, using cutting-edge technology to solve everyday problems.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-heart-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">User-Centric</h3>
                <p className="text-gray-600">
                  Every feature we build is designed with our users in mind. Simplicity and usability are at the core of everything we do.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Trust</h3>
                <p className="text-gray-600">
                  We take data privacy and security seriously. Your information is protected with enterprise-grade security measures.
                </p>
              </div>
            </div>
          </div>

          {/* Mission Statement */}
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Our Mission</h2>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              To eliminate the frustration of lost items and help people reclaim their time by creating 
              the world's most intuitive organization system. We believe everyone deserves to live in an organized, 
              stress-free environment where finding what you need is effortless.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}